"use client";

import { usePathname, useRouter } from "@/src/navigation";
import { useParams, useSearchParams } from "next/navigation";
import { useTransition } from "react";
import Image from "next/image";
import { useLocale } from "next-intl";
import GlobeIcon from "@/public/icons/globe.svg";

const LocaleSwitcherSelect = () => {
  const [isPending, startTransition] = useTransition();
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const params = useParams();
  const locale = useLocale();

  const isArabic = locale === "ar";
  const targetLocale = isArabic ? "en" : "ar";
  const label = isArabic ? "English" : "العربية";

  function onSwitch() {
    startTransition(() => {
      router.replace(
        {
          pathname,
          // @ts-expect-error - params might be empty, which is fine
          params,
          query: Object.fromEntries(searchParams),
        },
        { locale: targetLocale },
      );
    });
  }

  return (
    <button
      dir="ltr"
      onClick={onSwitch}
      disabled={isPending}
      className="flex items-center gap-2 text-white cursor-pointer"
    >
      <Image src={GlobeIcon} alt="Language switcher globe icon" />
      <span className="caption-text">{label}</span>
    </button>
  );
};

export default LocaleSwitcherSelect;
